import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
    const { t } = useTranslation("common");
    return (
        <div className="flex h-full items-center justify-center">
            <h1>{t("notFound")}</h1>
        </div>
    );
};

export default NotFoundPage;
